export const HORIZONTAL_STEP = 1;

export const HorizontalMoveDirection = {
  LEFT: 0,
  RIGHT: 1,
} as const;
export type HorizontalMoveDirection = (typeof HorizontalMoveDirection)[keyof typeof HorizontalMoveDirection];

export const VERTICAL_STEP = 1;

export const VerticalMoveDirection = {
  UP: 0,
  DOWN: 1,
} as const;
export type VerticalMoveDirection = (typeof VerticalMoveDirection)[keyof typeof VerticalMoveDirection];
